module.exports = __webpack_public_path__ + "media/images/icons/facebook-3779f950572e98eeed3ee0932d89c7f7.svg";